import React from 'react'
import { NavLink } from 'react-router-dom'

import ReactGA from 'react-ga';
ReactGA.initialize('UA-114391227-1');

export default () => (
  <header className='Header-header'>

    <h1 className='Header-h1'><b>SUPPORT FAQ</b></h1>
    <nav className='Header-nav'>
      <NavLink
        exact to='/'
        className='Header-navLink'
        activeClassName='Header-isActive'
      >
        Home
      </NavLink>
      <NavLink
        to='/another-page'
        className='Header-navLink'
        activeClassName='Header-isActive'
      >
        Another-Page
      </NavLink>
      <NavLink
        to='/about?authuser=1'
        className='Header-navLink'
        activeClassName='Header-isActive'
      >
        About
      </NavLink>
    </nav>
  </header>
)



// WEBPACK FOOTER //
// ./src/components/Header.js